"use client"
import { useGSAP } from "@gsap/react"
import clsx from "clsx"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { useRef } from "react"
import Cta from "@/components/cta/cta"

import Map from "@/components/icon/map"
import Navigation from "@/components/icon/navigation"
import {STORIES_BASE_PATH} from "@/constants/routes";
import { useApp } from "@/context/AppContext"


export default function RecordsStickyNav({isSticky}) {
  const { isAppReady, setIsRecordsNavOverlayOpen } = useApp()
  const root = useRef(null)

  const isInFooter = useRef(false);

  useGSAP(() => {
    if (isSticky) {
      return
    }

    ScrollTrigger.create({
      start: 'bottom-=134px bottom',
      end: 'bottom bottom',
      scrub: true,
      onUpdate: (self) => {
        if (isInFooter.current) {
          gsap.killTweensOf(root.current, 'y')
          gsap.set(root.current, {
            y: `${-134 * self.progress}`
          })
        }
      },
      onEnter: () => {
        isInFooter.current = true;
      },
      onLeaveBack: () => {
        isInFooter.current = false;
      }
    })
  })

  useGSAP(() => {
    if (isAppReady) {
      const mm = gsap.matchMedia();

      mm.add("(prefers-reduced-motion: reduce)", () => {
        gsap.set(root.current, {
          opacity: 1,
          y: '0%'
        })
      });

      mm.add("(prefers-reduced-motion: no-preference)", () => {
        gsap.to(root.current, {
          opacity: 1,
          duration: 0.4,
          ease: 'linear.none',
          delay: 1
        })

        gsap.fromTo(root.current, {
          y: '100%'
        }, {
          y: '0%',
          duration: 1.2,
          ease: 'expo.out',
          delay: 1
        })
      });

      return () => mm.revert();
    }
  }, [isAppReady])
  return (
    <nav ref={root} className={clsx(
      "w-full bottom-(--space-7) gap-x-(--space-3) left-0 flex justify-center z-20 opacity-0 will-change-transform",
      isSticky ? "sticky" : 'fixed '
    )}>
      <Cta className={clsx("cta-icon cta-icon-stroke-theme", isSticky ? "cta-theme-reverse" : "cta-bottom-theme-reverse")} href={`${STORIES_BASE_PATH}/map`} transitionName="overlay-in"><Map /><span>Map</span></Cta>
      <Cta className={clsx("cta-icon cta-icon-stroke-theme", isSticky ? "cta-theme-reverse" : "cta-bottom-theme-reverse")} onClick={() => setIsRecordsNavOverlayOpen(true)}><Navigation /><span>Categories</span></Cta>
    </nav>
  )
}
